import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { Checkbox } from "./ui/checkbox";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "./ui/dialog";

export function usePermOptions(enabled = true) {
  const [o, setO] = useState(null);
  useEffect(() => { if (enabled) api.get("/company/perm-options").then((r) => setO(r.data)).catch(() => setO({ perms: [], roles: {} })); }, [enabled]);
  return o;
}

export function PermissionPicker({ options, value, onChange }) {
  if (!options) return <div className="text-xs text-slate-400">Carregando permissões...</div>;
  const toggle = (k, on) => onChange(on ? [...value, k] : value.filter((x) => x !== k));
  return (
    <div className="grid sm:grid-cols-2 gap-x-4 gap-y-1.5 rounded-lg border bg-slate-50/60 p-3 max-h-72 overflow-y-auto" data-testid="perm-picker">
      {options.perms.map((p) => (
        <label key={p.key} className={`flex items-start gap-2 text-sm ${p.grantable ? "cursor-pointer" : "opacity-50"}`} title={p.grantable ? "" : "Você não tem esta permissão, por isso não pode concedê-la"}>
          <Checkbox checked={value.includes(p.key)} disabled={!p.grantable} onCheckedChange={(v) => toggle(p.key, !!v)} className="mt-0.5" data-testid={`perm-${p.key}`} />
          <span>{p.label}</span>
        </label>))}
    </div>);
}

export function UserPermsDialog({ user, open, onOpenChange, onSaved, endpoint }) {
  const options = usePermOptions(open);
  const [perms, setPerms] = useState([]);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (user) setPerms(user.effective_perms || []); }, [user]);
  const save = async () => {
    setBusy(true);
    try { await api.put(endpoint(user.id), { perms }); toast.success("Permissões atualizadas"); onOpenChange(false); onSaved?.(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-xl" data-testid="user-perms-dialog">
        <DialogHeader><DialogTitle>Permissões de {user?.name}</DialogTitle>
          <DialogDescription>Marque o que este usuário pode fazer no sistema. A alteração vale a partir do próximo clique dele e fica registrada na auditoria.</DialogDescription></DialogHeader>
        <PermissionPicker options={options} value={perms} onChange={setPerms} />
        <DialogFooter><Button variant="outline" onClick={() => onOpenChange(false)}>Cancelar</Button><Button onClick={save} disabled={busy} data-testid="user-perms-save">{busy ? "Salvando..." : "Salvar permissões"}</Button></DialogFooter>
      </DialogContent>
    </Dialog>);
}
